import { NavigationLink } from '../app/shared/interfaces/navigation-link';

export const navigation: NavigationLink[] = [
  /*  {
        label: 'خانه', url: '/home'
    },{
        label: 'راهنمای خرید', url: '/shop/takeaway'
    },{
        label: ' فهرست کالا', url: '/shop/quickreorder'
    },{
         label: 'پیشنهاد', url: '/shop/offers'
    },{
        label: 'قوانین فروش', url: '/site/deliveries'
    },{
         label: 'مقایسه', url: '/shop/compare'
    },*/

    // {label: 'فهرست محصولات', url: './shop', menu: {
    //     type: 'megamenu',
    //     size: 'nl',
    //     columns: [
    //         {size: 6, items: [
    //             {label: 'بهداشتی', url: './shop/category/100/بهداشتی', items: [
    //                 {label: 'Engravers', url: './shop'},
    //                 {label: 'Wrenches', url: './shop'},
    //                 {label: 'Wall Chaser', url: './shop'},
    //                 {label: 'Pneumatic Tools', url: './shop'}
    //             ]},
    //             {label: 'مراقبت از پوست', url: './shop', items: [
    //                 {label: 'Thread Cutting', url: './shop'},
    //                 {label: 'Chip Blowers', url: './shop'},
    //                 {label: 'Sharpening Machines', url: './shop'},
    //                 {label: 'Pipe Cutters', url: './shop'},
    //                 {label: 'Slotting machines', url: './shop'},
    //                 {label: 'Lathes', url: './shop'}
    //             ]}
    //         ]},
    //         {size: 6, items: [
    //             {label: ' مراقبت از مو', url: './shop', items: [
    //                 {label: 'Screwdrivers', url: './shop'},
    //                 {label: 'Handsaws', url: './shop'},
    //                 {label: 'Knives', url: './shop'},
    //                 {label: 'Axes', url: './shop'},
    //                 {label: 'Multitools', url: './shop'},
    //                 {label: 'Paint Tools', url: './shop'}
    //             ]},
    //             {label: ' آرایشی', url: './shop', items: [
    //                 {label: 'Motor Pumps', url: './shop'},
    //                 {label: 'Chainsaws', url: './shop'},
    //                 {label: 'Electric Saws', url: './shop'},
    //                 {label: 'Brush Cutters', url: './shop'}
    //             ]}
    //         ]}
    //     ]
    // }},
    {label: 'Shop', url: './shop', menu: {
        type: 'menu',
        items: []
    }},
    // {label: 'Account', url: './account', menu: {
    //     type: 'menu',
    //     items: [
    //         {label: 'Login',           url: './account/login'},
    //         {label: 'Dashboard',       url: './account/dashboard'},
    //         {label: 'Edit Profile',    url: './account/profile'},
    //         {label: 'Order History',   url: './account/orders'},
    //         {label: 'Address Book',    url: './account/addresses'},
    //         {label: 'Change Password', url: './account/password'}
    //     ]
    // }},
    {label: 'Blog', url: './blog'
    //, menu: {
       // type: 'menu',
      //  items: []
        //  [
        //     {label: 'Blog Classic',         url: './blog/category-classic'},
        //     {label: 'Blog Grid',            url: './blog/category-grid'},
        //     {label: 'Blog List',            url: './blog/category-list'},
        //     {label: 'Blog Left Sidebar',    url: './blog/category-left-sidebar'},
        //     {label: 'Post Page',            url: './blog/post-classic'},
        //     {label: 'Post Without Sidebar', url: './blog/post-full'}
        // ]
    },
    {label: 'Introduction', url: './site', menu: {
        type: 'menu',
        items: [
            {label: 'About_Us',             url: './site/about-us'},
            {label: 'Contact_Us',           url: './site/contact-us'},
            {label: 'Contact_Us_Alt',       url: './site/contact-us-alt'},
            {label: '404',                  url: './site/not-found'},
            {label: 'Terms_And_Conditions', url: './site/terms'},
            {label: 'FAQ',                  url: './site/faq'},
            {label: 'Components',           url: './site/components'},
            {label: 'Typography',           url: './site/typography'}
        ]
    }},
    // {label: 'Buy Theme', url: 'https://themeforest.net/item/stroyka-tools-store-angular-7-template/23523630', external: true}
];
